export default {
  meta: {
    title: '项目详情'
  }
};
